import { render, staticRenderFns } from "./PromotionFormDialog.vue?vue&type=template&id=ff0a3968"
import script from "./PromotionFormDialog.vue?vue&type=script&lang=js"
export * from "./PromotionFormDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports